import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IconDashesHorizontal } from "@/components/_icons/IconDashesHorizontal";
import { cn } from "@/lib/cn";

interface DataSourceViewEmptyProps {
  className?: string;
}

export const DataSourceViewEmpty: FC<DataSourceViewEmptyProps> = ({ className }: DataSourceViewEmptyProps) => {
  const { t } = useTranslation("common");
  return (
    <div className="m-1 flex flex-row items-center gap-2 p-1">
      <IconDashesHorizontal className={cn(["h-4 w-4", className])} />
      <div className="whitespace-nowrap">{t("notAssigned")}</div>
    </div>
  );
};

export default DataSourceViewEmpty;
